import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=7812078c"
import script from "./InfoIcon.vue?vue&type=script&lang=ts"
export * from "./InfoIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports